import { alpha } from '@mui/material/styles';

import type { OverWritable } from '../../@types/settings';

export const input: OverWritable = {
  MuiTextField: {
    defaultProps: {
      variant: 'filled',
    },
  },
  MuiInputBase: {
    defaultProps: {
      margin: 'dense',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-disabled': {
          '& svg': { color: theme.palette.text.disabled },
        },
      }),
      input: ({ theme }) => ({
        '&::placeholder': {
          opacity: 1,
          color: theme.palette.text.disabled,
        },
      }),
    },
  },
  MuiInput: {
    styleOverrides: {
      underline: ({ theme }) => ({
        '&:before': {
          borderBottomColor: theme.palette.grey[500_56],
        },
      }),
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.body2,
      }),
    },
  },
  MuiFilledInput: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.grey[500_8],
        '&:hover': {
          backgroundColor: theme.palette.grey[500_16],
        },
        '&.Mui-error': {
          backgroundColor: alpha( theme.palette.error.main, 0.08 ),
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.action.focus,
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.action.disabledBackground,
        },
      }),
      input: ({ theme }) => ({
        ...theme.typography.body2,
      }),
      underline: ({ theme }) => ({
        '&:before': {
          borderBottomColor: theme.palette.grey[500_56],
        },
      }),
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.grey[500_32],
        },
        '&.Mui-disabled': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.action.disabledBackground,
          },
        },
      }),
    },
  },
};
